
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BatteriesParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Battery"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"programmedDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"conservationDelay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rule"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"conservation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":178}};
    doc.loc.source = {"body":"fragment BatteriesParts on Battery {\r\n  _id\r\n  number\r\n  startDate\r\n  programmedDate\r\n  conservationDelay\r\n  rule {\r\n    reference\r\n  }\r\n  conservation {\r\n    reference\r\n  }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
